import React, { useState, useEffect } from "react";
import axios from "axios";
import "./Sales.css"; // Import updated CSS
import MarketingdashboardAside from "./MarketingdashboardAside";

function Sales() {
  const [salesData, setSalesData] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    axios
      .get("https://cleezoclass.com:8443/api/sales-performance-table")
      .then((response) => {
        console.log("Fetched data:", response.data);
        setSalesData(response.data);
      })
      .catch((error) => {
        console.error("Error fetching sales performance data:", error);
        setErrorMessage("Error fetching data.");
      });
  }, []);

  

  return (
    <div className="sales-container-updated mainBlock">
      <MarketingdashboardAside />
    <h1 className="sales-title-updated">Sales Performance</h1>
    {errorMessage && <p className="sales-error-updated">{errorMessage}</p>}
  
    <div className="sales-table-wrapper-updated">
      <table className="sales-table-updated">
        <thead>
          <tr>
            <th className="sales-th-updated">Employee ID</th>
            <th className="sales-th-updated">Employee Name</th>
            <th className="sales-th-updated">Designation</th>
            <th className="sales-th-updated">Follow Up Date</th>
            <th className="sales-th-updated">Institute Name</th>
            <th className="sales-th-updated">Interest Shown</th>
          </tr>
        </thead>
        <tbody>
          {salesData.length > 0 ? (
            salesData.map((data) => (
              <tr key={data.id} className="sales-tr-updated">
                <td className="sales-td-updated">{data.empId}</td>
                <td className="sales-td-updated">{data.empName}</td>
                <td className="sales-td-updated">{data.designation}</td>
                <td className="sales-td-updated">{data.followupdate}</td>
                <td className="sales-td-updated">{data.institutename}</td>
                <td className="sales-td-updated">{data.interestshown}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td className="sales-td-updated" colSpan="6">No data available</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  </div>
  

  );
}

export default Sales;
